<template>
  <div>
    <form action="" @submit.prevent="sendResetPasswordLink">
      <div style="display: flex; flex-direction: column; align-items: flex-start; margin-bottom: 10px;">
        <label for="password" style="color: blue">Cambiar contraseña</label>
        <input type="password" style="border-radius: 5px" v-model="password">
      </div>
      <div style="display: flex; flex-direction: column; align-items: flex-start">
        <label for="password" style="color: blue">Confirmar</label>
        <input type="password" style="border-radius: 5px" v-model="confirmed">
      </div>
      <button style="background: rgb(219, 254, 84); border-radius: 5px; border: none; font-weight: bold; padding: 8px 16px; margin-top: 20px;">Confirmar</button>
      <hr />
      <div v-if="errors.password">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_536_387)">
        <path d="M13 13H11V7H13M13 17H11V15H13M12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2Z" fill="#FEDB5F"/>
        </g>
        <defs>
        <clipPath id="clip0_536_387">
        <rect width="24" height="24" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        <span>{{ errors.password[0] }}</span>
      </div>
      <div v-if="passwordSuccessfullyUpdated">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="#06B217"/>
        </svg>
        <span>Tu contraseña se actualizó correctamente</span>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    cellphone: Number,
  },
  data() {
    return {
      currencyFormat: Intl.NumberFormat('es-MX', {style: 'currency', currency: 'MXN'}),
      password: '',
      confirmed: '',
      errors: [],
      passwordSuccessfullyUpdated: false
    }
  },
  methods: {
/*     async sendResetPasswordLink() {
      console.log(this.cellphone);
      // if(!this.cellphone || this.cellphone.length < 10) alert('Ingresa el número de teléfono')
      try {                
          await axios.post('/auth/send-reset-link', {cellphone: this.cellphone})
      } catch (error) {
          console.log(error.response);
          // this.signInFormErrors = error.response.data.errors
      }
    }, */
    async sendResetPasswordLink() {
      console.log(this.cellphone);
      // if(!this.cellphone || this.cellphone.length < 10) alert('Ingresa el número de teléfono')
      try {                
          await axios.post('/auth/send-reset-link', {
            cellphone: this.cellphone,
            password: this.password,
            password_confirmation: this.confirmed
          })

          this.passwordSuccessfullyUpdated = true
      } catch (error) {
          console.log(error.response.data.errors);
          this.errors = error.response.data.errors
      }
    },
  }
}
</script>